const numberWithCommas = x => {
    return String(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export {numberWithCommas}
